import React, { useEffect } from 'react';
// import { User, UserManager } from 'oidc-client';
// import { PropsWithChildren } from "react";


// export interface CallbackComponentProps {
//   userManager: UserManager;
//   successCallback: (user: User) => void;
//   errorCallback?: (error: any) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
// }

export const CallbackComponent = (props) => {
  const { children, successCallback, errorCallback, userManager } = props;

  useEffect(() => {
    function onRedirectSuccess(user) {

      successCallback(user);
    }

    function onRedirectError(error) {
      if(errorCallback) {
        errorCallback(error);
      } else {
        throw new Error(`Error handling redirect callback: ${error.message}`);
      }
    }

    userManager.signinRedirectCallback()
      .then((user) => onRedirectSuccess(user))
      .catch((error) => onRedirectError(error));
  }, [userManager, successCallback, errorCallback]);

  /* eslint-disable react/jsx-no-useless-fragment */
  return (
    <>
      {children}
    </>
  );
}

export default CallbackComponent;